
function Jobs(props) {
    return (
      <div className="mainDisplay">
        <br />
        <h1 className="titleMain marginBottom darkMaroonText">
          ChicagoDAO Task Management Portal
        </h1>
        <h1 className="titleMain marginBottom darkMaroonText">
          Coming Soon™
        </h1>
      </div>
    );
  }
  
  export default Jobs;
